export default __webpack_public_path__ + "static/media/minun-hoitoni-white.4ccdd287.svg";